var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlineFilledSeat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2646 15.1836L18.4633 18.3326",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96627 15.1836L3.76758 18.3326",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.97043 13.7821C1.42961 12.0907 2.69154 10.3623 4.46727 10.3623H17.4041C19.1798 10.3623 20.4417 12.0907 19.9009 13.7821C19.5536 14.8681 18.5442 15.6051 17.4041 15.6051H4.46727C3.32709 15.6051 2.31768 14.8681 1.97043 13.7821Z",
    fill: "#F8F9FA",
    stroke: "#051B46",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6898 3.35383L4.77291 9.02049C4.47772 10.8448 5.88632 12.4997 7.73439 12.4997L14.0189 12.4997C15.8669 12.4997 17.2755 10.8448 16.9803 9.02049L16.0635 3.35383C15.8284 1.90084 14.5739 0.833008 13.102 0.833008H10.8766H8.65128C7.17939 0.833008 5.9249 1.90084 5.6898 3.35383Z",
    fill: "#F8F9FA",
    stroke: "#051B46",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineFilledSeat);
export default __webpack_public_path__ + "static/media/outline-filled-seat.6773505cfc778da1c0ca9ffc6d19083a.svg";
export { ForwardRef as ReactComponent };